import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import Button from 'components/atomic/Button';
import Card from 'components/atomic/layouts/Card';
import Text from 'components/atomic/layouts/Text';

const StyledTimestampContainer = styled.div`
  margin-top: ${theme.spaces.medium * 3 + 18}px;
  margin-bottom: ${theme.spaces.medium}px;
  padding-left: ${theme.spaces.regular}px;
  border-left: 4px solid ${theme.colors.indigo.primary};

  @media ${theme.devices.tablet} {
    margin-top: unset;
  }
`;

const DeliveryDateView = () => {
  return (
    <Card>
      <div>
        <Text
          size={theme.fontSizes.large2X}
          lineHeight={theme.fontSizes.large2X}
          weight={600}
          color={theme.colors.indigo.primary}
        >
          Next
          <br />
          Delivery
          <br />
          Date
        </Text>
      </div>
      <StyledTimestampContainer>
        <Text size={theme.fontSizes.large9X} lineHeight={theme.fontSizes.large9X} weight={600}>
          {new Date().toLocaleString('en-us', { day: '2-digit' })}
        </Text>
        <Text size={theme.fontSizes.large4X} lineHeight={theme.fontSizes.large4X} weight={600}>
          {new Date().toLocaleString('en-us', { month: 'long' })}
        </Text>
        <Text weight={600} color={theme.colors.gray.secondary}>
          {new Date().getFullYear()}
        </Text>
      </StyledTimestampContainer>
      <div>
        <Button color={theme.colors.indigo.primary}>
          {new Date().toLocaleString('en-us', { month: 'long' })}&nbsp;
          <span>Books</span>
        </Button>
      </div>
    </Card>
  );
};

export default DeliveryDateView;
